import { Link } from "react-router-dom";

var Modal = require("components/utility/AltModal");
var ValidatingInput = require("components/utility/ValidatingInput");
var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require('lib/web/WhooosReadingServices');
var Features = require("lib/account/Features");
var WebinarRegistration = require("components/support/WebinarRegistration");

require("users/teachers/paywall_modal.scss");

class PaywallModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var currentPaywallFeature = props.featureType;
		var expiredTrials = CurrentUser.get().account.expired_trials;

		var triedCurrentFeature = expiredTrials[currentPaywallFeature] != undefined;

		this.state = { showDemoForm: false, showWebinarReg: false, showConsultation: triedCurrentFeature };
	}

	showWebinarRegistration(e) {
		$wr.nope(e)
		this.setState({ showWebinarReg: true });
	}

	showDemoForm(e) {
		$wr.nope(e)
		this.setState({ showDemoForm: true });
	}

	validateForm() {
		return this.refs.myInput.validate()
	}

	handleSubmit(e) {
		$wr.nope(e)
		if (!this.validateForm()) {
			return;
		}

		var callback = $wr.apiHandler((response) => {
		});
		var userMessage = "Whooo's Reading School Interest (" + this.props.featureType 
			+ ") -- Teachers: " + this.refs.numTeachers.val() + " -- Administration: "
			+ this.refs.adminOpinion.val();

		var params = {
			contact_message: {
				message: userMessage
			}
		}

		var title = "Message Sent";
		var text = "Thank you for the message! We will contact you shortly.";
		CurrentUser.api().postContactMessages(params, callback);
		
		this.hide();
		this.setState({ showDemoForm: false })
		window.wrNotifications.triggerDropDownNotification({ title: title,
		text: text, icon: "ok-circle" }, 3000);

		var label = "paywall-" + this.props.featureType;
		Mycroft.newEvent({ category: "Requests", action: "request-demo", label: label });

	}

	show() {
		this.refs.modal.show();
	}

	hide() {
		this.refs.modal.hide();
	}

	onShow() {
		Mycroft.buildEventHandler({
			category: "Paywall", action: "show", label: this.props.featureType
		})
	}

	isSilverPaywall() {
		switch (this.props.featureType) {
			case PaywallModal.HISTORICAL_DATA:
			case PaywallModal.STUDENT_DIFFERENTIATION:
			case PaywallModal.LOG_READING:
			case PaywallModal.TEACHER_DASHBOARD:
			case PaywallModal.TEXT_TABLE_DATA:
			case PaywallModal.OVERDRAWN_ACCOUNT:
			case PaywallModal.ZPD_READING_LEVELS:
				return true;
			default:
				return false;
		}
	}
	getFeatureName() {
		switch (this.props.featureType) {
			case PaywallModal.INSIGHTS:
				return "Insights";
			case PaywallModal.PROGRESS:
				return "Progress Data";
			case PaywallModal.COMPARISONS:
				return "Comparison Data";
			case PaywallModal.QUIZ_FEATURES:
				return "Details & Comments";
			case PaywallModal.TEXT_SPECIFIC_QUESTIONS:
				return "Specific Questions";
			case PaywallModal.CLOZE_ASSESSMENTS:
				return "RLDs";
			case PaywallModal.EXERCISES:
				return "Exercises";
			case PaywallModal.LOG_READING:
				return "Reading Logs";
			case PaywallModal.HISTORICAL_DATA:
				return "Writing History";
			case PaywallModal.TEACHER_PICKS:
				return "Teacher's Picks";
			case PaywallModal.TEACHER_DASHBOARD:
				return "Assignment Dashboard";
			case PaywallModal.STUDENT_DIFFERENTIATION:
				return "Student Differentiation";
			case PaywallModal.TEXT_TABLE_DATA:
				return "Text Table";
			case PaywallModal.OVERDRAWN_ACCOUNT:
				return "Additional Accounts";
			case PaywallModal.ZPD_READING_LEVELS:
				return "ZPD Reading Levels";
			default:
				return "Whooo's Reading Silver";
		}
	}

	getFeatureBenefit() {
		switch (this.props.featureType) {
			case PaywallModal.CLOZE_ASSESSMENTS:
				return "RLDs";
			case PaywallModal.LOG_READING:
				return "track your students' reading";
			case PaywallModal.HISTORICAL_DATA:
				return "unlock student writing data";
			case PaywallModal.TEACHER_DASHBOARD:
				return "experience the Assignment Dashboard";
			case PaywallModal.STUDENT_DIFFERENTIATION:
				return "access student differentiation";
			case PaywallModal.TEXT_TABLE_DATA:
				return "unlock student text tables";
			case PaywallModal.OVERDRAWN_ACCOUNT:
				return "get more classes for Whooo's Reading";
			case PaywallModal.ZPD_READING_LEVELS:
				return "get more control over your students' accountability";		
			default:
				return "access this feature";
		}
	}

	getTrialFeatures() {
		switch (this.props.featureType) {
			case PaywallModal.INSIGHTS:
			case PaywallModal.EXERCISES:
			case PaywallModal.PROGRESS:
			case PaywallModal.COMPARISONS:
				return Features.DIGITAL_EXERCISES;
			case PaywallModal.QUIZ_FEATURES:
				return Features.AUTOGRADER_DATA + "," + Features.TEACHER_COMMENTS;
			case PaywallModal.TEXT_SPECIFIC_QUESTIONS:
				return Features.TEXT_SPECIFIC_QUESTIONS;
			case PaywallModal.CLOZE_ASSESSMENTS:
				return Features.CLOZE_ASSESSMENTS;
			case PaywallModal.TEACHER_PICKS:	
			case PaywallModal.LOG_READING:
				return Features.LOG_READING;
			case PaywallModal.HISTORICAL_DATA:
			case PaywallModal.TEACHER_DASHBOARD:
				return Features.HISTORICAL_DATA;
			default:
				return "";
		}
	}

	renderTrialOrWebinarActionSection() {
		var trialEventHandler = Mycroft.buildEventHandler({
			category: "Paywall", action: "start-trial", label: this.props.featureType + "-paywall"
		});

		var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=" + this.getTrialFeatures();
		var trialURL = WhooosReadingServices.ApiServer.url(trialPath);

		if (this.state.showWebinarReg) {
			var actionDisplay = (
				<div className="actionDisplay">
					<WebinarRegistration sourceFeature={ this.props.featureType + "-paywall" } />
				</div>
			);
		} else if (this.state.showConsultation) {
			var linkEventHandler = Mycroft.buildEventHandler({
				category: "Paywall", action: "schedule-consultation", label: this.props.featureType + "-paywall"
			})
			var actionDisplay = (
				<div>
					<p>It looks like you completed a trial of <i>{ this.getFeatureName() }</i>. How did it go?</p>
					<p>
						Want to learn more about all of the features included in <i>Whooo's Reading
						School</i>? Schedule a free, 15-minute consultation to see if <i>Whooo's
						Reading School</i> is a good fit for your school.
					</p>
					<div className="actionSection">
						<a href="https://calendly.com/whooos-reading/wrs-consultation"
							className="buttonSuccess btn" target="_blank" onClick={ linkEventHandler }>
							Schedule My Consultation
						</a>
					</div>
				</div>
			)
		} else {

			if (this.props.featureType != PaywallModal.CLOZE_ASSESSMENTS) {
				var ctaQuestion = (
					<div className="ctaQuestion">
						What are your needs at this time?
					</div>
				)
				var dividerDot = (<div className="dividerDot"></div>)
				var actionDescription = (
					<div className="actionDescription">
						I would like to learn more about the basic features
						and how Whooo's Reading works in general...
					</div>	
				)
				var reserveWebinar = (
					<a href="#" onClick={ this.showWebinarRegistration } className="buttonPrimary actionButton">
						Reserve a Webinar Spot
					</a>	
				)
				var className = "actionOptionsSection"
			} else {
				var className = "actionOptionsSection rld"
			}

			var actionDisplay = (
				<div className="actionDisplay">
					<div className="actionOption">
						<div className="actionDescription">
							<i>Reading Level Diagnostics</i> can be purchased as an add-on to your teacher
							account, or at a discount with a <i>Whooo's Reading School</i> license.
						</div>
					</div>
					<div className="actionOption">
						{ actionDescription }
						{ reserveWebinar }
					</div>
					<a href={ trialURL } onClick={ trialEventHandler } className="buttonSuccess actionButton">
						Start Free Trial
					</a>
				</div>
			);
		}

		return (
			<div className={ className }>
				{ dividerDot }
				{ ctaQuestion }
				{ actionDisplay }
			</div>
		);
	}

	fetchFeatureContent() {
		if (this.state.showDemoForm) {
			return (
				<div>
					<p>Let us know where your school stands!</p>
					<form className="contactForm" onSubmit={ this.handleSubmit }>
						<p>
							How many teachers are interested in Whooo's Reading?
						</p>
						<ValidatingInput type="textarea" ref="numTeachers"
							validators={ ValidatingInput.Validators.PRESENT }
							placeholder="We have 5 teachers interested..."
							inputClassName="form-control messageArea"/>
						<br />
						<p>
							Does your administration know about the program? What do they think?
						</p>
						<ValidatingInput type="textarea" ref="adminOpinion"
							validators={ ValidatingInput.Validators.PRESENT }
							placeholder="Yes, my principal wants to learn about schoolwide data..."
							inputClassName="form-control messageArea"/>
						<br />
						<input className="buttonSuccess center-block" type="submit" value="Send" />
					</form>
				</div>
			)
		} else {

			//////////////////////////////////////////////////////////////////////////////
			////// in use for Silver paywalls ////////////////////////////////////////////
			//////////////////////////////////////////////////////////////////////////////
			if (this.props.featureType == PaywallModal.TEACHER_DASHBOARD) {
				var imgSrc = require("paywalls/dashboard.gif");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Easily monitor who in your class has completed their assignments with
							the <i>Assignment Dashboard</i> in Whooo's Reading Silver:
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.HISTORICAL_DATA) {
				var imgSrc = require("paywalls/new-data.gif");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							See all of your students' writing and the scores they received.
							Save time and access your students' grades all in one place.
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.TEXT_TABLE_DATA) {
				var imgSrc = require("paywalls/text-table.gif");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Immediately pull up a text table for each of your students to see the
							books they are reading, their quiz and answer scores, and more:
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.STUDENT_DIFFERENTIATION) {
				var imgSrc = require("paywalls/differentiation.gif");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Unlock full student-by-student differentiation:
							choose who gets sentence starters and warm-up questions; tailor the question and grading
							difficulty to challenge each student according to their level.
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.ZPD_READING_LEVELS) {
				var imgSrc = require("paywalls/zpd-reading-levels.gif");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Change any student's academic or reading level and keep them more accountable by
							automatically or manually excluding any work completed for a book below their Zone of Proximal Development (ZPD).
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.LOG_READING) {
				var imgSrc = require("paywalls/log-reading.gif");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Track your students' independent reading time within Whooo's Reading
							using <i>Reading Logs</i>, part of Whooo's Reading Silver.
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.OVERDRAWN_ACCOUNT) {
				var featureExplanation = (
					<div>
						<p>
							Whooo's Reading Silver allows for as many classes as you need.
						</p>
					</div>
				);

				

			//////////////////////////////////////////////////////////////////////////////
			////// end Silver paywalls ///////////////////////////////////////////////////
			//////////////////////////////////////////////////////////////////////////////

			} else if (this.props.featureType == PaywallModal.TEACHER_PICKS) {
				var featureExplanation = (
					<div>
						<p>
							Send your students specific texts you want them to be writing about,
							using Teacher's Picks, part of a <i>Whooo's Reading School</i> license.
						</p>
					</div>
				);

			} else if (this.props.featureType == PaywallModal.INSIGHTS) {
				var imgSrc = require("paywalls/insights.png");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							<i>Insights</i> is available under <i>Whooo's Reading 
							Gold</i>. This feature can help you identify trends in students' and classes' performance.
						</p>
						{ middleContent }
					</div>
				);
			} else if (this.props.featureType == PaywallModal.QUIZ_FEATURES) {
				var imgSrc = require("paywalls/quiz-features.png");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Learn how a <i>Whooo's Reading School</i> license can make student 
							quizzes really come to life!
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == Features.TEXT_SPECIFIC_QUESTIONS) {
				var imgSrc = require("paywalls/text-specific-questions.png");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Thousands of <i>Text-Specific Questions</i> come with 
							a <i>Whooo's Reading School</i> license.
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.CLOZE_ASSESSMENTS) {
				var imgSrc = require("paywalls/cloze-category-and-passage.gif");
				var middleContent = (
					<img src={ imgSrc } className="paywallImg" alt=""/>
				);
				var featureExplanation = (
					<div>
						<p>
							Track your students' reading levels throughout the year
							with Lexile-based cloze assessments, called <i>Reading Level Diagnostics</i>.
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.PROGRESS) {
				var middleContent = (
					<ul>
						<li>
							See how Whooo's Reading has helped your students' critical thinking
							skills improve throughout the school year.
						</li>
						<li>
							Compare their growth to your class average and the national average
							for students in a similar demographic.
						</li>
					</ul>
				);
				var featureExplanation = (
					<div>
						<p>
							Critical thinking progress graphs for each of your students are
							included with a <i>Whooo's Reading School</i> license.
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.COMPARISONS) {
				var middleContent = (
					<ul>
						<li>
							See how each of your students is doing in each standard compared to
							the national average for students in a similar demographic.
						</li>
						<li>
							Use individual and classwide patterns in critical thinking progress
							to help inform instruction.
						</li>
					</ul>
				);
				var featureExplanation = (
					<div>
						<p>
							Individual student comparison data is available with
							a <i>Whooo's Reading School</i> license.
						</p>
						{ middleContent }
					</div>
				);

			} else if (this.props.featureType == PaywallModal.EXERCISES) {
				var middleContent = (
					<ul>
						<li>
							Assign Exercises to reinforce the reading comprehension skills you
							are currently teaching in class.
						</li>
						<li>
							Use recommended Exercises from the Insights section to target
							and strengthen areas of weakness.
						</li>
					</ul>
				);
				var featureExplanation = (
					<div>
						<p>
							<i>Whooo's Reading School</i> gives you access to hundreds of
							standards-aligned Exercises that help students improve specific skills.
						</p>
						{ middleContent }
					</div>
				);
			}

			if (this.isSilverPaywall()) {
				var expiredSilverTrial = CurrentUser.get().account.expired_trials.wrSilver != undefined;

				if (!expiredSilverTrial) {
					var trialEventHandler = Mycroft.buildEventHandler({
						category: "Paywall", action: "start-silver-trial", label: this.props.featureType + "-paywall"
					});
					var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=wrSilver&days=30";
					var trialURL = WhooosReadingServices.ApiServer.url(trialPath);

					var optionLink = (
						<a href={ trialURL } onClick={ trialEventHandler } className="actionButton">
							Start Free Trial
						</a>
					);

					var ctaSentence = "Upgrade your account, or start a 30-day free trial."
				} else {
					// var ctaSentence = "Upgrade your account today."
					var trialEnded = (
						<p className="trialEnded">Your trial has ended. We hope you enjoyed it!</p>
					)
					var ctaFullSentence = (
						<p>Upgrade your account today or schedule a free, 15-minute consultation to see if <i>Whooo's
						Reading Silver</i> is a good fit for you.</p>
					)
					var consulationURL = "https://calendly.com/whooos-reading/wrs-consultation"
					var optionLink = (
						<a href={ consulationURL } className="actionButton" target="_blank" 
							onClick={ linkEventHandler }>
							Schedule My Consultation
						</a>
					);
				}

				var upgradeEventHandler = (e) => {
					$wr.nope(e)
					Mycroft.newEvent({
						category: "Paywall", action: "silver-upgrade-page", label: this.props.featureType + "-paywall"
					});

					this.hide();

					$wr.redirect("/upgrade?plan=silver");
				}

				var actionSection = (
					<div>
						{ trialEnded }
						{ ctaFullSentence }
						<div className="actionSection">
							<a href="#" onClick={ upgradeEventHandler }
								className="btn buttonSuccess upgradeButton">
								Upgrade to Silver
							</a>
							{ optionLink }
						</div>
					</div>
				);

			} else if (this.props.featureType == PaywallModal.INSIGHTS) {
				var linkEventHandler = Mycroft.buildEventHandler({
					category: "Paywall", action: "schedule-consultation", label: this.props.featureType + "-paywall"
				})
				if (!this.state.showConsultation) {
					var trialEventHandler = Mycroft.buildEventHandler({
						category: "Paywall", action: "start-trial", label: this.props.featureType + "-paywall"
					});

					var upgradeURL = "https://www.whooosreading.org/pricing"
					var actionSection = (
						<div>
							<p>
								Upgrade to Gold to gain access to <i>Insights</i> and get a feel for
								what Whooo's Reading can do!
							</p>
							<div className="actionSection">
								<a href={ upgradeURL } className="buttonSuccess actionButton">
									View Plans
								</a>
							</div>
						</div>
					);
				} else {
					var actionSection = (
						<div>
							<p>
								It looks like you have completed a trial of <i>{ this.getFeatureName() }</i>. Did you like it?
								Want to learn more about all of the features included in <i>Whooo's Reading
								School</i>? Schedule a free, 15-minute consultation to see if <i>Whooo's
								Reading School</i> is a good fit for your school.
							</p>
							<div className="actionSection">
								<a href="https://calendly.com/whooos-reading/wrs-consultation"
									className="buttonSuccess btn" target="_blank" onClick={ linkEventHandler }>
									Schedule My Consultation
								</a>
							</div>
						</div>
					);
				}
			} else {
				var actionSection = this.renderTrialOrWebinarActionSection();
			}

			return (
				<div>
					{ featureExplanation }
					{ actionSection }
				</div>
			)
		}
	}

	render() {
		var paywallModalContent = (
			<div className="paywallContentContainer">
				{ this.fetchFeatureContent() }
			</div>
		)

		var feature = this.props.featureType;
		if (this.isSilverPaywall()) {
			var headerText = "Whooo's Reading Silver";
		} else {
			var headerText = this.getFeatureName();
		}
		
		return (
			<Modal className="paywallModal" onShow={ this.onShow } onHide={ this.props.onHide }
				ref="modal" headerText={ headerText }>
				{ paywallModalContent }
			</Modal>
		);
	}

	componentDidMount() {
		if (this.props.selfOpen) {
			this.refs.modal.show();
		}
	}
};

PaywallModal.propTypes = StrictPropTypes({
	featureType: PropTypes.string,
	onHide: PropTypes.func,
	selfOpen: PropTypes.bool
});

PaywallModal.INSIGHTS = "insights";
PaywallModal.PROGRESS = "progress";
PaywallModal.COMPARISONS = "comparisons";
PaywallModal.QUIZ_FEATURES = "quizzes";
PaywallModal.TEXT_SPECIFIC_QUESTIONS = "text-specific-questions";
PaywallModal.CLOZE_ASSESSMENTS = "cloze-assessments";
PaywallModal.EXERCISES = "exercises";
PaywallModal.LOG_READING = "log-reading";
PaywallModal.HISTORICAL_DATA = "historical-data";
PaywallModal.TEACHER_PICKS = "teacher-picks";
PaywallModal.STUDENT_DIFFERENTIATION = "student-differentiation";
PaywallModal.TEACHER_DASHBOARD = "teacher-dashboard";
PaywallModal.TEXT_TABLE_DATA = "text-table-data";
PaywallModal.OVERDRAWN_ACCOUNT = "overdrawn-account";
PaywallModal.ZPD_READING_LEVELS = "zpd-reading-levels";

module.exports = PaywallModal;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/PaywallModal.js